export function initializeDatepicker() {
    if (!window.gform?.utils?.addFilter) {
        return;
    }

    window.gform.utils.addFilter('gform/datepicker/pre_init', (data) => {
        data.options.openOnFocus = true;

        return data;
    });
}
